/* Campagne-homepage: meting van homepage-interacties en de directe winkelwagenknop. Vanilla, defer.
 * Eén event 'home_interaction' naar de bestaande GTM-dataLayer en naar Shopify.analytics (customer events),
 * met campagnecontext (autumn_2026, winter_2026, black_friday_2026). Geen dubbele e-commerce-events:
 * add_to_cart blijft van Shopify zelf (de winkelwagen-API triggert dat standaard event).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-ch-campaign]');
  if (!root || window.__chHome) return;
  window.__chHome = true;
  var CAMPAIGN = root.getAttribute('data-ch-campaign') || 'none';
  try { (window.dataLayer = window.dataLayer || []).push({ campaign: CAMPAIGN, page_type_home: 'campaign_home' }); } catch (e) {}

  function track(interaction, detail, section) {
    var payload = { event: 'home_interaction', campaign: CAMPAIGN, interaction: interaction, detail: detail || '', home_section: section || '' };
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('home_interaction', { campaign: CAMPAIGN, interaction: interaction, detail: detail || '', home_section: section || '' });
      }
    } catch (e) {}
  }
  function sectionOf(el) {
    var s = el.closest('[data-ch-section]');
    if (s) return s.getAttribute('data-ch-section');
    var ss = el.closest('.shopify-section');
    return ss ? ss.id.replace(/^shopify-section-template--\d+__/, '') : '';
  }

  // Klikken: eigen elementen via data-ch-track, overige product- en categorielinks op de homepage via delegatie
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a, button');
    if (!a) return;
    var t = a.getAttribute('data-ch-track');
    if (t) { track(t, a.getAttribute('data-ch-detail') || '', sectionOf(a)); return; }
    if (!a.closest('main')) {
      if (a.closest('header') && a.matches('summary, [href*="search"], .header__icon--search, details-modal summary')) track('search_open', '', 'header');
      return;
    }
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([^?#/]+)/);
    if (m) { track('product_click', m[1], sectionOf(a)); return; }
    m = href.match(/\/collections\/([^?#/]+)/);
    if (m) { track('category_click', m[1], sectionOf(a)); return; }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/search"]')) track('search_submit', (f.querySelector('[name="q"]') || {}).value || '', 'header');
  }, true);

  // Secties in beeld (één keer), zodat scrolldiepte per sectie zichtbaar is
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { track('section_view', x.target.getAttribute('data-ch-section'), ''); io.unobserve(x.target); } });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-ch-section]').forEach(function (s) { io.observe(s); });
  }

  // Directe winkelwagenknop: via de Ajax-API met de bestaande cart drawer; zonder drawer valt het formulier terug op /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ch-quick-add]')) return;
    var drawer = document.querySelector('cart-drawer');
    var btn = form.querySelector('button');
    track('quick_add', btn ? btn.getAttribute('data-ch-detail') : '', sectionOf(form));
    if (!drawer || !window.fetch) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    var ids = [];
    try { ids = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (x) { ids = ['cart-drawer', 'cart-icon-bubble']; }
    fd.append('sections', ids.join(','));
    fd.append('sections_url', window.location.pathname);
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { form.submit(); return; }
        var txt = btn.querySelector('.ch-add__txt');
        btn.classList.add('is-added'); if (txt) txt.textContent = 'Toegevoegd';
        drawer.classList.remove('is-empty');
        try { drawer.renderContents(res); } catch (x) { window.location.href = (window.routes && routes.cart_url) || '/cart'; }
        setTimeout(function () { btn.classList.remove('is-added'); if (txt) txt.textContent = 'In winkelwagen'; }, 2500);
      })
      .catch(function () { form.submit(); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  });
})();
